import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BrandLogo } from "@/components/BrandLogo";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida com sucesso! Faça login.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <BrandLogo />
        <h2 className="mt-8 font-display text-xl font-bold text-slate-900">Nova senha</h2>
        <p className="mt-1 text-sm text-slate-500">Defina uma nova senha para sua conta.</p>
        {!token && <p className="mt-4 text-sm text-red-600">Link inválido. Solicite um novo link.</p>}
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="password">Nova senha</Label>
            <Input id="password" type="password" data-testid="reset-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)} minLength={6} required disabled={!token} />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button"
            className="h-11 w-full bg-blue-700 hover:bg-blue-800">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Redefinir senha"}
          </Button>
        </form>
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-blue-700 hover:underline">
          <ArrowLeft className="h-4 w-4" /> Voltar para o login
        </Link>
      </div>
    </div>
  );
}
